import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { Resource } from '@opentelemetry/resources';

const provider = new WebTracerProvider({
  resource: new Resource({
    'service.name': process.env.REACT_APP_OTEL_SERVICE_NAME || 'servicehubcrmvideocall',
    'service.version': '0.7.0',
  }),
});

// Sends traces via nginx proxy: /otel/v1/traces → otel-collector:4318/v1/traces
// OTLPTraceExporter requires an absolute URL (rejects relative paths)
provider.addSpanProcessor(
  new BatchSpanProcessor(
    new OTLPTraceExporter({ url: `${window.location.origin}/otel/v1/traces` }),
    { maxExportBatchSize: 20, scheduledDelayMillis: 5000 }
  )
);

provider.register();

registerInstrumentations({
  instrumentations: [
    new FetchInstrumentation({
      propagateTraceHeaderCorsUrls: [/servicehubvirtualportal\.net/],
      clearTimingResources: true,
    }),
    new XMLHttpRequestInstrumentation({
      propagateTraceHeaderCorsUrls: [/servicehubvirtualportal\.net/],
    }),
  ],
});
